/* Joonys Versand-Fortschrittsbalken.
   Liest window.JoonysShipping (aus shipping-config.liquid) + /cart.js, rechnet Pfand raus,
   ermittelt die Stufe und aktualisiert alle [data-shipping-bar] live.
   Update-Quelle: pfand:synced (von pfand-sync.js nach jeder Cart-Mutation) — kein Doppel-System.
   App-sicher (eigenes Asset). */
(function () {
  var cfg = window.JoonysShipping;
  if (!cfg || !cfg.enabled) return;

  function formatMoney(cents) {
    cents = Math.max(0, Math.round(cents));
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && cfg.moneyFormat) {
      try { return window.Shopify.formatMoney(cents, cfg.moneyFormat); } catch (e) {}
    }
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  // Pfand-Line-Items erkennen (variant_id / genested / Tag system:pfand)
  function isPfandLine(item) {
    var pid = window.JoonysPfand && window.JoonysPfand.pfandVariantId;
    if (pid != null && String(item.variant_id) === String(pid)) return true;
    if (item.parent_relationship && item.parent_relationship.parent_key) return true;
    if (item.product && item.product.tags && item.product.tags.indexOf &&
        item.product.tags.indexOf('system:pfand') !== -1) return true;
    return false;
  }

  function eligibleSubtotal(cart) {
    if (!cfg.excludePfand) return cart.items_subtotal_price;
    return (cart.items || []).reduce(function (sum, item) {
      return isPfandLine(item) ? sum : sum + item.final_line_price;
    }, 0);
  }

  // Aktive Stufen (dedupe per from → unkonfigurierte from:0-Stufen fallen raus, außer der Basis)
  function getTiers() {
    var seen = {}, out = [];
    (cfg.tiers || [])
      .filter(function (t) { return t && typeof t.from === 'number'; })
      .sort(function (a, b) { return a.from - b.from; })
      .forEach(function (t) {
        if (seen[t.from]) return;
        seen[t.from] = 1;
        out.push(t);
      });
    return out;
  }

  function compute(amount) {
    var ts = getTiers();
    if (!ts.length) return null;
    var cur = ts[0], next = null;
    for (var i = 0; i < ts.length; i++) {
      if (amount >= ts[i].from) cur = ts[i];
      else { next = ts[i]; break; }
    }
    var goal = ts[ts.length - 1].from || 1;          // höchste Schwelle (Gratis-Ziel)
    var displayMax = goal / 0.9;                      // ~10% Headroom rechts → Gratis-Marker bei ~90%, Label passt
    var reached = !!(cur && cur.cost === 0);
    var pct = reached ? 100 : Math.max(0, Math.min(100, (amount / displayMax) * 100));
    return { cur: cur, next: next, pct: pct, reached: reached, ts: ts, top: displayMax };
  }

  function syncMarkers(bar, amount, ts, top) {
    var container = bar.querySelector('[data-shipping-markers]');
    if (!container) return;
    if (container.getAttribute('data-built') !== '1') {
      container.innerHTML = '';
      ts.forEach(function (t) {
        if (t.from <= 0) return; // Basis-Stufe nicht markieren
        var pct = Math.min(100, (t.from / top) * 100);
        var mk = document.createElement('span');
        mk.className = 'joonys-shipping-bar__marker' + (pct >= 99.5 ? ' is-end' : '');
        mk.style.left = pct + '%';
        mk.setAttribute('data-from', t.from);
        var lbl = document.createElement('span');
        lbl.className = 'joonys-shipping-bar__marker-label';
        lbl.textContent = (t.cost === 0) ? 'gratis' : formatMoney(t.from);
        mk.appendChild(lbl);
        container.appendChild(mk);
      });
      container.setAttribute('data-built', '1');
    }
    var marks = container.querySelectorAll('.joonys-shipping-bar__marker');
    for (var j = 0; j < marks.length; j++) {
      marks[j].classList.toggle('is-reached', amount >= Number(marks[j].getAttribute('data-from')));
    }
  }

  function message(state, amount) {
    if (state.reached) return cfg.text.reached;
    if (!state.next) return '';
    var remaining = formatMoney(state.next.from - amount);
    if (state.next.cost === 0) {
      return cfg.text.freeNext.replace('[remaining]', remaining);
    }
    var nextLabel = cfg.text.labelReduced.replace('[cost]', formatMoney(state.next.cost));
    return cfg.text.progress.replace('[remaining]', remaining).replace('[nextLabel]', nextLabel);
  }

  function render(amount) {
    var bars = document.querySelectorAll('[data-shipping-bar]');
    if (!bars.length) return;
    var state = compute(amount);
    if (!state) return;
    var msg = message(state, amount);
    for (var i = 0; i < bars.length; i++) {
      var bar = bars[i];
      bar.hidden = false;
      bar.classList.toggle('is-complete', state.reached);
      var m = bar.querySelector('[data-shipping-msg]');
      if (m) m.textContent = msg;
      var fill = bar.querySelector('[data-shipping-fill]');
      if (fill) fill.style.width = state.pct + '%';
      var track = bar.querySelector('.joonys-shipping-bar__track');
      if (track) track.setAttribute('aria-valuenow', state.pct);
      syncMarkers(bar, amount, state.ts, state.top);
    }
  }

  var inFlight = false;
  function refresh() {
    if (inFlight) return;
    inFlight = true;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(eligibleSubtotal(cart)); })
      .catch(function () {})
      .then(function () { inFlight = false; });
  }

  // Primär: Pfand-Sync-Event (Pfand ist dann settled)
  document.addEventListener('pfand:synced', refresh);
  document.addEventListener('DOMContentLoaded', function () { setTimeout(refresh, 300); });
  if (document.readyState !== 'loading') setTimeout(refresh, 300);

  // Fallback, falls Pfand-System aus ist (dann gibt's kein pfand:synced)
  if (!(window.JoonysPfand && window.JoonysPfand.enabled) && window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function () {
      var arg0 = arguments[0];
      var url = arg0 && (arg0.url || arg0);
      var p = origFetch.apply(this, arguments);
      if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) {
        p.then(function () { setTimeout(refresh, 80); });
      }
      return p;
    };
  }
})();
